import * as React from 'react';
import { isNil } from 'lodash';

import ExtendsContextMenuItem from './ExtendsContextMenuItem';

import { withModal } from 'components/modal/ModalHOC';
import SubcampaignCancellationFeedbackModal from 'modules/feedback/components/SubcampaignCancellationFeedbackModal';

import { isAccepted, isPending } from 'utils/subcampaign';

import type { ContextMenuItem } from 'types';

type Props = {
  item: ContextMenuItem,
  onModalClosed?: (a: React.MouseEvent) => void
};

class ContextMenuItemCancelOffer extends ExtendsContextMenuItem<Props> {
  render(): React.ReactNode {
    const { item, onModalClosed } = this.props;
    const subcampaign = item.meta ? item.meta.subcampaign : undefined;

    if (isNil(subcampaign)) {
      return null;
    }

    if (isPending(subcampaign) || isAccepted(subcampaign)) {
      const CancelOfferWithFeedback = withModal(<span />, {
        modalContent: SubcampaignCancellationFeedbackModal,
        onModalClosed
      });

      return (
        <CancelOfferWithFeedback
          modalContentProps={{
            subcampaign,
            campaignType: item.meta?.campaignType,
            redirectTo: item.meta?.redirectTo
          }}
        >
          <div className="context-menu-item__text">
            {item.text}
          </div>
        </CancelOfferWithFeedback>
      );
    }

    return null;
  }
}

export default ContextMenuItemCancelOffer;
